
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class ShowSingleList extends Vue {
  @Prop(Array) public itemList!: any;
  @Prop(Array) public rangeList!: any;
  private dialog: boolean = false;
  private selectedItem: any = null;


  private get listObj() {
    if (this.rangeList?.length === 1) {
      const arrReturned: any = this.itemList.map((e) => {
        return {status: 'AUSENTE', register: e};
      });
      return arrReturned;

    } else if (this.rangeList?.length > 1) {
      let x = this.rangeList[0];
      const arrReturned: any = [];
      if (x >= this.rangeList[1]) {
        return [];
      }
      while (x <= this.rangeList[1]) {
        if (this.isInList(x)) {
          arrReturned.push({status: 'REGISTRADO', register: x});
        } else {
          arrReturned.push({status: 'AUSENTE', register: x});
        }
        x++;
      }
      return arrReturned;
    }
    return [];
  }

  private isInList(val) {
    /* tslint:disable-next-line */
    return this.itemList.find((e: number) => e == Number(val));
  }

  private getCurrentClassRow(item) {
    if (item === 'AUSENTE') {
      return 'error';
    }
    return 'success';
  }


}
